import gql from 'graphql-tag';

export const GET_CLIENT_DEBT_INFO_LIST = gql`
  query getClientDebtInfoList($listInfoInput: ListInfoInput!) {
    getClientDebtInfoList(listInfoInput: $listInfoInput) {
      listInfo {
        page
        pageSize
        totalCount
        hasMore
      }
      clientDebtInfos {
        totalInvoicesOverdue
        outstandingAmount
        client {
          accountId
          name
        }
      }
    }
  }
`;

export const GET_CLIENT_INVOICE_STATEMENT_LIST = gql`
  query getClientInvoiceStatementList($listInfo: ListInfoInput!) {
    getClientInvoiceStatementList(listInfoInput: $listInfo) {
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
      clientInvoiceStatements {
        client {
          accountId
          name
        }
        outstandingAmount
        creditsAvailable
        unpaidInvoices
        lastPaymentReceived
      }
    }
  }
`;

export const GET_PAID_INVOICE_LIST = gql`
  query getInvoiceList($listInfo: ListInfoInput) {
    getInvoiceList(listInfo: $listInfo) {
      invoices {
        invoiceId
        displayId
        invoiceDate
        totalAmount
        paymentDate
      }
      listInfo {
        hasMore
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;
